module.exports = "<template> <div class=tyl-backdrop></div> </template>";